export enum Color {
    redMoov = "redMoov",
    black = "black",
    white = "white",
    grey = "grey",
    darkGrey = "darkGrey",
    lightGrey = "lightGrey",
    blueGrey = "blueGrey",
    greenGrey = "greenGrey",
    mc4 = "mc4",
    checkInPurple = "checkInPurple",
    transparent = "transparent",
    error = "error",
    success = "success",
    warning = "warning",
    info = "info",
    purple = "purple",
    blue = "blue",
    darkBlue = "darkBlue",
    lightBlue = "lightBlue",
    green = "green",
    red = "red",
    cyan = "cyan",
    pink = "pink",
    azur = "azur",
    seaBlue = "seaBlue",
    darkGreen = "darkGreen",
    darkViolet = "darkViolet",
    payBlue = "payBlue",
    payBlueSecondary = "payBlueSecondary",
    darkRed = "darkRed",
    cityYello = "cityYello",
    cityYellow = "cityYellow",
    cityGrey = "cityGrey",
}

export enum GradientColor {
    checkInPurple = "checkInPurple",
    miaka = "miaka",
    dracula = "dracula",
    softPurple = "softPurple",
    mantle = "mantle",
    titanium = "titanium",
    seaBlizz = "seaBlizz",
    midnightCity = "midnightCity",
    shroomHaze = "shroomHaze",
    veniceBlue = "veniceBlue",
    kashmir = "kashmir",
    talkingToMiceElf = "talkingToMiceElf",
    blueGrad = "blueGrad",
    yellowGrad = "yellowGrad",
    blackGrad = "blackGrad",
    ohHappiness = "ohHappiness",
    orangeCoral = "orangeCoral",
    scooter = "scooter",
    azurLane = "azurLane",
    mielGrad = "mielGrad",
    citrusPeel = "citrusPeel",
    orangeCity = "orangeCity",
    cileamoov = "cileamoov",
    cileamoov2 = "cileamoov2",
    lightGreyGrad = "lightGreyGrad",
    velociti = "velociti",
    demat = "demat",
}
